// utils/wow.js
import WOW from "wowjs";

export const initWOW = () => {
  if (typeof window !== "undefined") {
    const wow = new WOW.WOW({
      live: false, // IMPORTANT for React
      offset: 0,
    });
    wow.init();
  }
};
